(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        /* Desktop mega panels stay expanded; sidebar columns switch via click/focus, not hover */
        const isLargeScreen = window.matchMedia('(min-width: 1025px)').matches;
        this.disclosure.open = isLargeScreen;
        this.toggle.removeAttribute('tabindex');
      }

      handleToggle(e) {
        const isDesktopMegaNav = this.matches('.js-mega-nav') && window.matchMedia('(min-width: 1025px)').matches;
        if (isDesktopMegaNav) return;
        /* Tablet/mobile drawer: MainMenu handles nav toggles; avoid blocking touch on summary. */
        if (window.matchMedia('(max-width: 1024px)').matches) return;
        super.handleToggle(e);
      }
    }

    customElements.define('nav-menu', NavMenu);

    // Wire the mobile burger button to toggle the main menu (menu lives in header__bottom which is hidden until open)
    customElements.whenDefined('main-menu').then(() => {
      const burger = document.querySelector('.header__burger');
      const mainMenu = document.querySelector('main-menu');
      const details = document.getElementById('main-menu-disclosure');
      if (!burger || !mainMenu || !mainMenu.mainDisclosure) return;

      const isMobileNavLayout = () => window.matchMedia('(max-width: 1024px)').matches;

      const shouldCompactMenuChrome = () => {
        if (!isMobileNavLayout()) return false;
        try {
          const vv = window.visualViewport;
          if (vv && typeof vv.scale === 'number' && vv.scale > 1.02) return true;
        } catch (e) {}
        if (window.innerHeight <= 600) return true;
        if (window.innerWidth <= 520) return true;
        return false;
      };

      const syncCompactMenuChromeClass = () => {
        const compact = !!(details && details.open && shouldCompactMenuChrome());
        document.documentElement.classList.toggle('main-menu--open-compact', compact);
      };

      let compactRaf = null;
      const scheduleCompactMenuChromeClass = () => {
        if (compactRaf) cancelAnimationFrame(compactRaf);
        compactRaf = requestAnimationFrame(() => {
          compactRaf = null;
          syncCompactMenuChromeClass();
        });
      };

      const syncMobileMenuPanelLayout = () => {
        const storeHeader = document.querySelector('store-header');
        if (storeHeader && typeof storeHeader.setHeaderEnd === 'function') {
          storeHeader.setHeaderEnd();
        }
        if (typeof window.setViewportHeight === 'function') {
          window.setViewportHeight();
        }
        if (typeof window.setHeaderHeight === 'function') {
          window.setHeaderHeight();
        }
      };

      const scheduleMobileMenuPanelLayout = () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            syncCompactMenuChromeClass();
            syncMobileMenuPanelLayout();
          });
        });
        setTimeout(() => {
          syncCompactMenuChromeClass();
          syncMobileMenuPanelLayout();
        }, 50);
        setTimeout(() => {
          syncCompactMenuChromeClass();
          syncMobileMenuPanelLayout();
        }, 320);
      };

      const scheduleHeaderLayoutSync = () => {
        scheduleCompactMenuChromeClass();
        if (isMobileNavLayout()) {
          if (details && details.open) scheduleMobileMenuPanelLayout();
        } else {
          document.documentElement.classList.remove('main-menu--open-compact');
          syncMobileMenuPanelLayout();
        }
      };

      /* Do not use mainToggle.click(): the summary is display:none and synthetic clicks are unreliable (mouse at high zoom). */
      burger.addEventListener('click', (e) => {
        const willOpen = details && !details.open;
        mainMenu.handleMainMenuToggle(e);
        scheduleMobileMenuPanelLayout();
        if (willOpen && isMobileNavLayout()) {
          setTimeout(() => {
            mainMenu.restoreMobileTopLevelMenuFocus();
          }, 50);
        }
      });

      if (details) {
        const syncAria = () => {
          burger.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        };
        const onDetailsOpenChange = () => {
          syncAria();
          syncCompactMenuChromeClass();
          scheduleMobileMenuPanelLayout();
        };
        syncAria();
        syncCompactMenuChromeClass();
        const observer = new MutationObserver(onDetailsOpenChange);
        observer.observe(details, { attributes: true, attributeFilter: ['open'] });
      }

      window.addEventListener('resize', scheduleHeaderLayoutSync);
      window.addEventListener('on:breakpoint-change', scheduleHeaderLayoutSync);
      try {
        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', scheduleHeaderLayoutSync);
        }
      } catch (e) {}
    });
  });

  const closeHeaderPredictiveSearch = () => {
    const predictiveSearch = document.querySelector('.header__search predictive-search[open]');
    if (!predictiveSearch) return;

    const input = predictiveSearch.querySelector('.js-search-input');
    const resetBtn = predictiveSearch.querySelector('.js-search-reset');
    const overlay = predictiveSearch.querySelector('.js-search-overlay');
    const results = predictiveSearch.querySelector('.js-search-results');

    predictiveSearch.removeAttribute('open');
    predictiveSearch.classList.remove('is-open');
    if (resetBtn) resetBtn.hidden = true;
    if (overlay) overlay.classList.remove('is-visible');
    if (input) {
      input.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-activedescendant', '');
      input.blur();
    }
    if (results) {
      results.hidden = true;
      results.setAttribute('hidden', '');
    }

    document.body.classList.remove('overlay-predictive-search');
    predictiveSearch.closest('.header__search')?.classList.remove('is-search-open');
    predictiveSearch.closest('.header__top')?.classList.remove('is-search-open');
    predictiveSearch.closest('store-header')?.classList.remove('is-search-open');
  };

  document.addEventListener('keydown', (evt) => {
    if (evt.key !== 'Escape') return;
    if (!document.querySelector('.header__search predictive-search[open]')) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    closeHeaderPredictiveSearch();
  }, true);

  document.addEventListener('mousedown', (evt) => {
    const predictiveSearch = document.querySelector('.header__search predictive-search[open]');
    if (!predictiveSearch || predictiveSearch.contains(evt.target)) return;
    closeHeaderPredictiveSearch();
  }, true);

  } catch(e) { console.error(e); }
})();
})();
